export default {
      id: "experience-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#experience-usage",
      toString: function () {
        return this.url;
      }
    }